// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1VC87","logo":"Header_logo__3_SJs","exit":"Header_exit__2hSTo"};